/* @ngInject */
function TwoFactorVerificationController ($scope, $rootScope, $location, $timeout, $stateParams, $state, $translate, AuthService, IntercomService, InitializerService, SegmentService, BackendErrorParserService) {
  const host = $location.host()
  $scope.subdomain = ''
  $scope.backgroundUrl = ''

  $scope.flags = {
    loadingBackground: true,
    invalidCode: false,
    loadingLogin: false,
    resendCodeSuccess: false,
    resendCodeError: false
  }

  $scope.codeInputs = {
    input0: '',
    input1: '',
    input2: '',
    input3: '',
    input4: '',
    input5: ''
  }

  let linkAction = 'RESEND'

  const api = {
    _focusOnInput,
    _addValueToInput,
    _containsOnlyNumbers,
    _getVerificationCode,
    _addEventListenerOnInputs,
    _successResendCode,
    _errorResendCode,
    _successLogin,
    _errorLogin
  }
  this.getApi = () => api

  activate()

  function activate () {
    AuthService.setContainerPosition()
    AuthService.getCustomerImages(host).then(url => {
      $scope.subdomain = localStorage.getItem('companySubdomain')
      $scope.backgroundUrl = url.background
    }).finally(() => {
      $scope.flags.loadingBackground = false
    })

    $scope.userEmail = $stateParams.email

    $timeout(() => {
      api._focusOnInput(0)
      api._addEventListenerOnInputs()
    }, 100, false)
  }

  $translate.onReady(() => {
    $scope.linkText = $translate.instant('twoFactorVerification.sendNewCode')
  })

  $scope.onInputChange = (index) => {
    const value = $(`.two-factor-verification .verification-inputs .code-input#input${index}`).val()
    if (value === '') {
      $scope.codeInputs[`input${index}`] = ''
      return
    }

    api._addValueToInput(value, index)
  }

  $scope.login = () => {
    $scope.flags.loadingLogin = true
    $scope.flags.invalidCode = false
    const verificationCode = api._getVerificationCode()

    AuthService.validateMFA($stateParams.token, verificationCode, $stateParams.password)
      .then(api._successLogin)
      .catch(api._errorLogin)
      .finally(() => { $scope.flags.loadingLogin = false })
  }

  $scope.resendCode = () => {
    if (linkAction === 'RESEND') {
      $scope.flags.resendCodeSuccess = false
      $scope.flags.resendCodeError = false

      AuthService.resendMFA($stateParams.token).then(api._successResendCode).catch(api._errorResendCode)
    } else {
      IntercomService.show()
    }
  }

  $scope.exit = () => {
    $state.go('login')
  }

  function _focusOnInput (index) {
    $('.two-factor-verification .verification-inputs input').blur()
    $(`.two-factor-verification .verification-inputs #input${index}`).focus()
  }

  function _addEventListenerOnInputs () {
    $('.code-input').on('keydown', (e) => {
      if (e.key === 'Backspace') {
        $timeout(() => {
          const inputId = e.target.id
          const index = parseInt(inputId.replace('input', ''))
          if (index > 0) {
            const previousInputIndex = index - 1
            api._focusOnInput(previousInputIndex)
          }
        }, 0, false)
      }
    })
  }

  function _addValueToInput (values, index) {
    const isIllegalCharacter = !api._containsOnlyNumbers(values[0])

    if (isIllegalCharacter) {
      $(`.two-factor-verification .verification-inputs #input${index}`).val('')
      $scope.codeInputs[`input${index}`] = ''
      api._focusOnInput(index)
      return
    }

    $(`.two-factor-verification .verification-inputs #input${index}`).val(values[0])
    $scope.codeInputs[`input${index}`] = parseInt(values[0])
    const nextInputIndex = index + 1
    const lastIndex = 5

    if (values.length > 1 && index < lastIndex) {
      api._addValueToInput(values.slice(1), nextInputIndex)
    } else if (index === lastIndex) {
      $scope.login()
    } else {
      api._focusOnInput(nextInputIndex)
    }
  }

  function _containsOnlyNumbers (value) {
    return /^\d+$/.test(value)
  }

  function _getVerificationCode () {
    let verificationCode = ''

    for (const input in $scope.codeInputs) {
      verificationCode += $scope.codeInputs[input]
    }

    return verificationCode
  }

  function _successResendCode () {
    $scope.linkText = $translate.instant('twoFactorVerification.codeResendSuccess')
    $scope.flags.resendCodeSuccess = true
    linkAction = 'CHAT'

    $timeout(() => {
      $scope.linkText = $translate.instant('twoFactorVerification.speakNowWithChat')
    }, 2000)
  }

  function _errorResendCode (e) {
    if (e.status === 429) {
      $scope.flags.resendCodeError = true
    } else {
      $scope.exit()
    }
  }

  function _successLogin () {
    return InitializerService.initApplication().then(() => {
      const onboardingStatus = String($rootScope.oUser.onboarding_status)

      const redirects = {
        COMPANY: () => {
          $state.go('onboardingStepCompany')
        },
        MODULES: () => {
          $state.go('onboardingStepModules')
        },
        BRANDING: () => {
          $state.go('onboardingStepBranding')
        },
        DEFAULT: () => {
          const params = $location.search()
          if (params.next) {
            $location.url(params.next)
          } else {
            $state.go('home')
          }
        }
      }

      if (redirects[onboardingStatus]) {
        redirects[onboardingStatus]()
      } else {
        redirects.DEFAULT()
      }

      $timeout(() => {
        SegmentService.track('user-login', { id: $rootScope.oUser.id, sso_enabled: false })
      }, 100, false)
    })
  }

  function _errorLogin (error) {
    if (BackendErrorParserService.shouldHaveStrongPassword(error)) {
      $state.go('updatePassword', { token: error.data.data.token, oldPassword: $stateParams.password, username: error.data.data.username, type: 'strength' })
    } else if (BackendErrorParserService.isPasswordExpired(error)) {
      $state.go('updatePassword', { token: error.data.data.token, oldPassword: $stateParams.password, username: error.data.data.username, type: 'expiration' })
    } else {
      $scope.flags.invalidCode = true
    }
  }
}

export { TwoFactorVerificationController }
